import * as React from "react";
import { InputBase, styled } from "@mui/material";

//region [[ Styles ]]

const ColorBoxView = styled("div")({
  display: "flex",
  flexFlow: "row",
  border: "1px solid black",
  padding: 0,
  width: "fit-content",
  background: "#efefef",
  margin: "5px",
});

const ColorPreview = styled("div")({
  borderLeft: "1px solid gray",
  height: "30px",
  width: "30px",
});

const ColorInput = styled(InputBase)({
  width: "105px",
  paddingLeft: "5px",
  background: "white",
  height: "30px",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ColorBoxProps {
  onChange: (colorInString: string) => void;
  onColorClick: () => void;
  color: string;
  disabled?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ColorBox = ({ ...props }: ColorBoxProps) => {
  return (
    <ColorBoxView>
      <ColorInput
        startAdornment={"#"}
        onClick={props.onColorClick}
        value={props.color?.replace?.("#", "") || ""}
      />
      <ColorPreview
        style={{ backgroundColor: props.color }}
        onClick={props.onColorClick}
      />
    </ColorBoxView>
  );
};
